import React, { useEffect, useState } from 'react';
import { authService } from '../services/auth';
import { toast } from 'react-toastify';

const Verify = ({ onBackToLanding }) => {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('Verificando...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Token de verificación faltante');
      return;
    }

    (async () => {
      try {
        const res = await authService.verify(token);
        setStatus('success');
        setMessage(res?.message || 'Email verificado. Ya puedes iniciar sesión.');
        // Si el backend devuelve token y user, iniciar sesión automáticamente
        if (res?.token && res?.user) {
          authService.saveSession(res.token, res.user);
          toast.success('Cuenta verificada. Has sido autenticado.');
          // Puedes redirigir al dashboard recargando o ajustando la vista
          window.location.href = '/';
        }
      } catch (err) {
        setStatus('error');
        setMessage(err?.response?.data?.error || err.message || 'Error al verificar');
      }
    })();
  }, []);

  return (
    <div className="auth-form">
      <button type="button" className="btn-back" onClick={onBackToLanding}>
        ← Volver al inicio
      </button>
      <h2>Verificando cuenta</h2>
      {/* <p>{message}</p> */}
      {status === 'loading' && <p>⏳ {message}</p>}
      {status === 'success' && <p className="success">✅ {message}</p>}
      {status === 'error' && <p className="error">❌ {message}</p>}
    </div>
  );
};

export default Verify;